import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import styled from 'styled-components';
import { Button } from '@ipc/ipc-components';
import { FormattedMessage } from 'react-intl';
import {
  applyButtonStyle,
  cancelButtonStyle,
  clearButtonStyle,
  filterButtonStyle,
  filterSelectionStyle,
  titleStyle,
} from './ColumnFilter.style';
import { getActiveFilterByColumnId } from '../selectors/ListTableSelectors';

const initialState = {
  showFilter: false,
  applied: undefined,
  current: undefined,
};

const Title = styled.h4`${titleStyle}`;

const FilterButton = styled(Button)`${filterButtonStyle}`;

const ApplyButton = styled(Button)`${applyButtonStyle}`;

const ClearButton = styled(Button)`${clearButtonStyle}`;

const CancelButton = styled(Button)`${cancelButtonStyle}`;

const FilterSelection = styled.div`${filterSelectionStyle}`;

class ColumnFilter extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  setCurrent = (current) => {
    this.setState({ current });
  };

  applyFilter = () => {
    const { onChange } = this.props;
    const { current } = this.state;
    this.setState((prevState) => ({
      showFilter: false,
      applied: prevState.current,
    }));
    onChange(current);
  };

  cancelFilter = () => {
    this.setState((prevState) => ({
      showFilter: false,
      current: prevState.applied,
    }));
  };

  clearFilter = () => {
    const { onChange } = this.props;
    this.setState(initialState);
    onChange({ clearFilter: true });
  };

  showFilter = () => {
    this.setState({
      showFilter: true,
    });
  };

  isValid = () => {
    const { current } = this.state;
    return current && current.valid;
  };

  activeClass = () => {
    const { applied } = this.state;
    const { activeFilter } = this.props;
    return applied || activeFilter.some((appliedFilter) => !appliedFilter.value.clearFilter)
      ? 'active' : 'inactive';
  };

  renderHiddenFilter = () => (
    <FilterButton className={`${this.activeClass()}`} onClick={this.showFilter}>
      <FormattedMessage id="filter-component.action.filter" />
    </FilterButton>
  );

  renderFilter = () => {
    const { render, column } = this.props;
    const { current } = this.state;

    return (
      <FilterSelection>
        <Title>{column.Header}</Title>
        {render(current, this.setCurrent)}
        <ApplyButton disabled={!this.isValid()} onClick={this.applyFilter}>
          <FormattedMessage id="filter-component.action.apply" />
        </ApplyButton>
        <ClearButton onClick={this.clearFilter}>
          <FormattedMessage id="filter-component.action.clear-filter" />
        </ClearButton>
        <CancelButton onClick={this.cancelFilter}>
          <FormattedMessage id="filter-component.action.cancel" />
        </CancelButton>
      </FilterSelection>
    );
  };

  render() {
    const {
      showFilter,
    } = this.state;
    return (
      <div className="advanced-filter">
        {showFilter ? this.renderFilter() : this.renderHiddenFilter()}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  activeFilter: getActiveFilterByColumnId(state, props.column.id),
});

ColumnFilter.propTypes = {
  onChange: PropTypes.func,
  column: PropTypes.shape({
    Header: PropTypes.string,
    id: PropTypes.string,
    accessor: PropTypes.func,
  }),
  render: PropTypes.func,
  activeFilter: PropTypes.arrayOf(PropTypes.object),
};

ColumnFilter.defaultProps = {
  activeFilter: [],
};

export default connect(mapStateToProps)(ColumnFilter);
